// extracted by mini-css-extract-plugin
export default {"container":"container__SocialMediaLinks__2KRed","mediaIcon":"mediaIcon__SocialMediaLinks__2KRed"};